import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Clock_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2.75C5.10051 2.75 2.75 5.10051 2.75 8C2.75 10.8995 5.10051 13.25 8 13.25C10.8995 13.25 13.25 10.8995 13.25 8C13.25 5.10051 10.8995 2.75 8 2.75ZM1.25 8C1.25 4.27208 4.27208 1.25 8 1.25C11.7279 1.25 14.75 4.27208 14.75 8C14.75 11.7279 11.7279 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8ZM8 4.25C8.41421 4.25 8.75 4.58579 8.75 5V7.53647L10.3354 8.32918C10.7059 8.51442 10.8561 8.96493 10.6708 9.33541C10.4856 9.70589 10.0351 9.85606 9.66459 9.67082L7.66459 8.67082C7.4105 8.54378 7.25 8.28408 7.25 8V5C7.25 4.58579 7.58579 4.25 8 4.25Z"
            />
        </SvgStyled>
    );
};

export default Clock_xs;
